/* START: ChatGPT Customization - Related products desktop/tablet placement */
(() => {
  const largeViewport = window.matchMedia('(min-width: 750px)');
  const recommendationsSelector = 'product-recommendations.related-products';
  const mediaWrapperSelector = "product-info[id^='MainProduct-'] .product__media-wrapper";

  let state = null;

  const getMovableSection = () => {
    const recommendations = document.querySelector(recommendationsSelector);
    if (!recommendations) return null;

    const sectionShell = recommendations.parentElement;
    return sectionShell?.classList.contains('gradient') ? sectionShell : recommendations;
  };

  const rememberOrigin = (node) => {
    if (state?.node === node) return;

    state = {
      node,
      parent: node.parentNode,
      nextSibling: node.nextSibling,
    };
  };

  const restoreOrigin = () => {
    if (!state?.node || !state.parent?.isConnected) return;

    const { node, parent, nextSibling } = state;
    if (node.parentNode === parent) {
      node.classList.remove('sk-related-products-docked');
      return;
    }

    if (nextSibling?.parentNode === parent) {
      parent.insertBefore(node, nextSibling);
    } else {
      parent.appendChild(node);
    }

    node.classList.remove('sk-related-products-docked');
  };

  const syncPlacement = () => {
    const node = getMovableSection();
    if (!node) {
      state = null;
      return;
    }

    rememberOrigin(node);

    if (!largeViewport.matches) {
      restoreOrigin();
      return;
    }

    const mediaWrapper = document.querySelector(mediaWrapperSelector);
    if (!mediaWrapper) return;

    if (node.parentNode !== mediaWrapper) {
      mediaWrapper.appendChild(node);
    }

    node.classList.add('sk-related-products-docked');
  };

  const scheduleSync = () => window.requestAnimationFrame(syncPlacement);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }

  if (typeof largeViewport.addEventListener === 'function') {
    largeViewport.addEventListener('change', scheduleSync);
  } else {
    largeViewport.addListener(scheduleSync);
  }

  document.addEventListener('shopify:section:load', scheduleSync);
  document.addEventListener('shopify:section:reorder', scheduleSync);
})();
/* END: ChatGPT Customization - Related products desktop/tablet placement */
